import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import CustomDataGrid from '../../../../reusable-components/datagrid/CustomDataGrid';
import Iconify from '../../../../reusable-components/iconify';
import { getBudgetItemDetailsData } from '../../../../api/orders';
import { BUDGET_HISTORY } from '../../../../reusable-components/datagrid/orderColumns';
import { HOST_API_URL } from '../../../../config-global';
import { AwaitButton } from '../../../../reusable-components/await-button';
import CloseIconButton from '../../../../reusable-components/basic-buttons/CloseIconButton';
import { formatLocalDateAsUtcMidnight } from '../../../../utils/formatTime';

HistoryModal.propTypes = {
  openModal: PropTypes.bool,
  setOpenModal: PropTypes.func,
  includeUnapproved: PropTypes.bool,
  budgetDate: PropTypes.any,
  catId: PropTypes.number,
  facId: PropTypes.any,
  subcategoryId: PropTypes.number,
  tab: PropTypes.number,
};

export default function HistoryModal({
  openModal,
  setOpenModal,
  includeUnapproved,
  budgetDate,
  catId,
  facId,
  subcategoryId,
  tab,
}) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const getBudgetItemDetails = async () => {
    const response = await getBudgetItemDetailsData({
      categoryId: catId,
      facilityId: facId,
      budgetDate,
      includeUnapproved,
      subcategoryId,tab 
    });
    if (response.status === 200) {
      setData(response.data);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (openModal) {
      getBudgetItemDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [catId, facId, includeUnapproved, openModal]);

  const handleClose = () => {
    setOpenModal(false);
  };

  return (
    <>
      <Dialog open={openModal} onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
        handleClose();
      }} maxWidth="xl" fullWidth>
        <DialogTitle
          sx={{
            textAlign: 'center',
          }}
        >
          Budget Ordered History
           <AwaitButton
            variant="outlined"
            sx={{ mr: 1, ml: 1 }}
            size="small"
            color="secondary"
            onClick={() => {
              window.open(
                `${HOST_API_URL}Api/DownloadBudgetItemDetailsData?facilityId=${facId}&categoryId=${catId}&includeUnapproved=${includeUnapproved}&budgetDate=${formatLocalDateAsUtcMidnight(budgetDate)}&subcategoryId=${subcategoryId}&yearPart=${tab}`,
                '_blank'
              );
            }}
            startIcon={<Iconify icon="file-icons:microsoft-excel" />}
          >
            Download
          </AwaitButton>
          <CloseIconButton onClick={handleClose}/>
        </DialogTitle>
        <DialogContent>
          <CustomDataGrid
            gridId="orders-new-order-history-modal"
            boxSX={{ height: 'calc(100vh - 240px)', width: '100%' }}
            data={data}
            gridColumns={BUDGET_HISTORY}
            sort={[{ field: 'orderNumber', sort: 'asc' }]}
            isModal
            isLoading={loading}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}
